
import { Component, Vue, Watch } from "vue-property-decorator";
import DFloatContainer from "@/components/DFloatContainer.vue";
import DContainerLayout from "@/views/base/DContainerLayout.vue";
import DList from "@/views/base/DList.vue";
import { API_REMIND_ADDTOFAVORITE, API_REMIND_EXPORT, API_REMIND_LIST, API_REMIND_REMOVEFROMFAVORITE } from "@/configs/Apis";
import { isEmpty, isEmptyOrWhiteSpace, isNull, showConfirm, showError, showSuccess, showWarning } from "@/utils/Common";
import { Fetcher } from "@/utils/Request";
import { MSG_001, MSG_ADD_FAV_SUCCESS, MSG_CANCEL_FAV_SUCCESS, MSG_EXPORT_FILE_NOTFOUND } from "@/configs/Consts";
import formatters from "@/utils/ColumnFormater";
import moment, { Moment } from "moment";
import PatentOperationDetail from "@/views/index/component/details/PatentOperationDetail.vue";
import pageIndex from "@/stores/modules/views/pageIndex";

@Component({
  components: {
    DFloatContainer,
    DContainerLayout,
    DList,
    PatentOperationDetail
  }
})
export default class FavPatentRemindList extends Vue {
  // $refs!: { remindgrid: DList };

  queryData: any = { remindDateOption: "all" };
  remindDetail: any = {};
  relRemindDetail: any = {};

  showRight = false;
  hasSelectedItems = false;

  queryStr = "";

  showSearch = false;

  created() {
    console.info(this.$route.meta?.type);
  }

  get searchBtnIcon(): string {
    return this.showSearch ? "el-icon-arrow-up" : "el-icon-arrow-down";
  }

  get dataApi() {
    return API_REMIND_LIST;
  }

  get colFormatters() {
    return formatters;
  }

  createTableColumns() {
    const columns: Array<TableColumnOption> = [
      {
        prop: "title",
        display: "标题",
        width: 300,
        formatter: (data: any, column: any, value: any) => {
          return `<div class="remind-list-title"><a href="javascript:void(0)" class="dudu-anchor ${data.readFlag ? "" : "unread-title el-icon-message-solid"}">${value}</a></div>`;
        }
      },
      {
        prop: "remindTime",
        display: "时间",
        width: 200
      },
      {
        prop: "messageType",
        display: "类型",
        width: 200,
        formatter: formatters.formatMessageType.bind(this)
      },
      {
        prop: "content",
        display: "内容",
        sortable: false,
        formatter: (data: any, column: any, value: any) => {
          return "点击查看详情";
        }
      }
    ];
    this.$store.dispatch("remindlist/setColumns", columns);
  }

  onModuleRegistered() {
    this.$nextTick(async () => {
      this.$store.registerModule("pageIndex", pageIndex);
      this.createTableColumns();
      this.onSearchConditionChange();
    });
  }

  beforeDestroy() {
    this.$store.unregisterModule("pageIndex");
  }

  onRemindDateChange(arrs: Array<string>) {
    if (arrs && arrs.length) {
      this.queryData.startDate = arrs[0];
      this.queryData.endDate = arrs[1];
    } else {
      (this.queryData.startDate as any) = undefined;
      (this.queryData.endDate as any) = undefined;
    }
    this.onSearchConditionChange();
  }

  @Watch("queryData.readFlag")
  onSearchConditionChange() {
    const fields = ["startDate", "endDate", "readFlag", "keyWord"];
    const params: { [key: string]: any } = {};
    fields.forEach(field => {
      params[field] = (this.queryData as any)[field];
    });
    if (!params.messageType) {
      params.messageType = "PATENT";
      params.favoriteFlag = true;
    }
    this.queryStr = JSON.stringify(params);
  }

  hideFloater() {
    this.showRight = false;
  }

  onSelectionChanged(selectedRows: any[]) {
    this.hasSelectedItems = selectedRows.length > 0;
  }

  onRowClick(row: any, column: any, event: MouseEvent) {
    if (event.stopPropagation) {
      event.stopPropagation();
    } else {
      event.cancelBubble = true;
    }
    (this.$refs.operation as any).open(row.content);

    this.remindDetail = JSON.parse(JSON.stringify(row));
    this.relRemindDetail = row;

    if (!this.remindDetail.readFlag) {
      this.$store.dispatch("remindlist/updateToReaded", this.remindDetail.id)
        .then(() => {
          row.readFlag = true;
        })
        .catch(() => "");
    }
  }

  @Watch("queryData.remindDateOption")
  onRemindDateOptionChange() {
    let now: Moment | null = moment();
    let startDate: Moment | null = moment();
    switch (this.queryData.remindDateOption) {
      case "oneweek":
        startDate = startDate.add(-7, "days");
        break;
      case "onemonth":
        startDate = startDate.add(-1, "months");
        break;
      case "threemonth":
        startDate = startDate.add(-3, "months");
        break;
      default:
        now = null;
        startDate = null;
        break;
    }
    if (!isEmpty(now)) {
      this.queryData.endDate = now!.format("YYYY-MM-DD");
    } else {
      (this.queryData.endDate as any) = undefined;
    }
    if (!isEmpty(startDate)) {
      this.queryData.startDate = startDate!.format("YYYY-MM-DD");
    } else {
      (this.queryData.startDate as any) = undefined;
    }
    if (this.queryData.remindDateOption !== "custom") {
      this.onSearchConditionChange();
    }
    if (this.queryData.remindDateOption !== "custom" && Reflect.has(this.queryData, "remindDate")) {
      this.queryData.remindDate = null;
    }
  }

  searchData() {
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = this.queryStr.trim();
    } else {
      this.queryStr += " ";
    }
  }

  exportData(cmd: string) {
    let params: any = {};
    if (cmd === "selected") {
      const selectedRows = (this.$refs.remindgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }

      params.selectedIds = selectedRows;
    } else {
      if (!isEmptyOrWhiteSpace(this.queryStr)) {
        params = JSON.parse(this.queryStr);
      }
    }
    Fetcher.queryData(API_REMIND_EXPORT, params).then(url => {
      if (isEmpty(url)) {
        showWarning(MSG_EXPORT_FILE_NOTFOUND);
        return;
      }
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("target", "_blank");
      document.body.appendChild(a);
      a.click();
      if (a.parentNode) {
        a.parentNode.removeChild(a);
      }
    }).catch(({ message }) => showError(message));
  }

  readSelected(cmd: string) {
    let params: any = {};
    let message = "是否将<span style='color:red;font-weight: 600'> 全部 </span>消息标记为已读?";
    if (cmd === "selected") {
      const selectedRows = (this.$refs.remindgrid as any).getSelectedRows();
      if (!selectedRows || selectedRows.length === 0) {
        showWarning("请至少选择一条数据");
        return;
      }
      params.selectedIds = selectedRows;
      message = `是否将选择的<span style="color:red;font-weight: 600"> ${selectedRows.length} </span>条消息标记为已读？`;
    } else {
      params = this.queryData;
    }
    showConfirm(message)
      .then(() => {
        this.$store.dispatch("remindlist/readRemind", params).then(() => showSuccess("标记成功"))
          .then(() => this.searchData())
          .catch(({ message }) => showError(message));
      }).catch(() => "");
  }

  deleteSelected() {
    const selectedRows = (this.$refs.remindgrid as any).getSelectedRows();
    if (!selectedRows.length) {
      return;
    }
    showConfirm(`是否将选择的 ${selectedRows.length} 条消息彻底删除？`)
      .then(() => {
        this.$store.dispatch("remindlist/deleteRemind", selectedRows).then(() => showSuccess("删除成功"))
          .then(() => this.searchData())
          .catch(({ message }) => showError(message));
      }).catch(() => "");
  }

  async cancelFav() {
    const selectedRows = (this.$refs.remindgrid as any).getSelectedRows();
    if (!selectedRows.length) {
      showWarning(MSG_001);
      return;
    }
    await this.$store.dispatch("remindlist/post", {
      api: API_REMIND_REMOVEFROMFAVORITE,
      params: { selectedIds: selectedRows }
    });
    showSuccess(MSG_CANCEL_FAV_SUCCESS);
    this.searchData();
  }

  async addFavItem() {
    const dataItem = this.remindDetail;
    if (isNull(dataItem)) {
      return;
    }
    await this.$store.dispatch("remindlist/post", {
      api: API_REMIND_ADDTOFAVORITE,
      params: { selectedIds: [dataItem.id] }
    });
    this.relRemindDetail.favoriteFlag = true;
    showSuccess(MSG_ADD_FAV_SUCCESS);
    this.searchData();
  }

  async cancelFavItem() {
    const dataItem = this.remindDetail;
    if (isNull(dataItem)) {
      return;
    }
    await this.$store.dispatch("remindlist/post", {
      api: API_REMIND_REMOVEFROMFAVORITE,
      params: { selectedIds: [dataItem.id] }
    });
    this.relRemindDetail.favoriteFlag = false;
    showSuccess(MSG_CANCEL_FAV_SUCCESS);
    this.searchData();
  }
}
